// @react/hooks/useProduct.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { productStore } from '@core/stores';

/**
 * React hook for Product operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProduct } from '@react/hooks';
 *
 * const ProductList = observer(() => {
 *   const store = useProduct();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProduct() {
  return productStore;
}
